import React, { useState } from 'react';
import TableComponent from '../../../component/molecules/Table/TableComponent';
import { scriptEndpoints } from 'hooks/endpoints';
import * as tableHeader from './factory/companyBotsHeader';
import { useNavigate } from 'react-router-dom';
import Header from 'component/layout/header/Header';
import EmbeddedCode from 'component/molecules/companyBots/embbededCode/EmbeddedCode';
import NewBot from 'component/molecules/companyBots/newbot/NewBot';
import RestrictAccess from 'component/molecules/companyBots/restrict-access/RestrictAccess';
import TourModal from 'component/hoc/tour-modal/TourModal';
import { useTour } from 'app-context/tourContext/TourContext';
const Bots = () => {
  const navigate = useNavigate();

  const [isCodeOpen, setIsCodeOpen] = useState(false);
  const [isNewBot, setIsNewBot] = useState(false);
  const [isRestrictAccess, setIsRestrictAccess] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const { showModal } = useTour();

  const handleSettings = (item) => {
    navigate(`/bot/analytics/${item.botId}`, {
      state: { botName: item?.botName, createdAt: item.createdOn },
    });
  };

  const handleEmbeddedCode = (item) => {
    setIsCodeOpen(true);
    setSelectedItem(item);
  };

  const handleRestrictAccess = (item) => {
    setIsRestrictAccess(true);
    setSelectedItem(item);
  };

  const handleCLose = () => {
    setIsCodeOpen(false);
    setIsNewBot(false);
    setSelectedItem(null);
    setIsRestrictAccess(false);
  };

  const rowButtons = [
    {
      type: 'icon',
      name: 'code',
      func: handleEmbeddedCode,
      iconTooltip: 'Copy Embedded Code',
    },
    {
      type: 'icon',
      name: 'settings',
      func: handleSettings,
      iconTooltip: 'Chat Settings',
    },
    {
      type: 'icon',
      name: 'restrict-access',
      func: handleRestrictAccess,
      iconTooltip: 'Restrict Access',
    },
  ];
  const filterButtons = [
    {
      type: 'button',
      label: 'New Bot',
      opicBackground: true,
      func: () => setIsNewBot(true),
      id: 'new-bot',
    },
  ];
  const handleRowClick = (item) => {
    navigate(`/bot/analytics/${item.botId}`, {
      state: { botName: item?.botName, createdAt: item.createdOn },
    });
  };
  return (
    <>
      <Header title="Bots" />
      <TableComponent
        rowKey="botId"
        headerData={tableHeader?.headerData}
        api={{
          get: {
            url: scriptEndpoints?.getCompanyBots,
            queryKey: 'companyBots',
          },
          toggleUrl: scriptEndpoints?.disableBot,
        }}
        actions={{
          onRowClick: {
            hasRowClick: true,
            func: handleRowClick,
          },
        }}
        rowButtons={rowButtons}
        filterButtons={filterButtons}
        isRefetch={refetch}
      />
      <EmbeddedCode
        onClose={handleCLose}
        isOpen={isCodeOpen}
        item={selectedItem}
      />
      <NewBot
        onClose={handleCLose}
        isOpen={isNewBot}
        setRefetch={setRefetch}
        selectedItem={null}
      />
      <RestrictAccess
        onClose={handleCLose}
        isOpen={isRestrictAccess}
        selectedItem={selectedItem}
        setRefetch={setRefetch}
      />
      {showModal && <TourModal />}
    </>
  );
};

export default Bots;
